import { render, staticRenderFns } from "./normal-date.vue?vue&type=template&id=e397e224&scoped=true&"
import script from "./normal-date.vue?vue&type=script&lang=js&"
export * from "./normal-date.vue?vue&type=script&lang=js&"
import style0 from "./normal-date.vue?vue&type=style&index=0&id=e397e224&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e397e224",
  null
  
)

export default component.exports